<template>
  <div>
    <Information />
    <Summary />
  </div>
</template>

<script>
import Summary from './Summary.vue'
import Information from './Information.vue'

export default {
  components: {
    Summary,
    Information,
  },
}
</script>
